module.exports = {"320583100":"玉山镇","320583101":"巴城镇","320583102":"周市镇","320583103":"陆家镇","320583104":"花桥镇","320583106":"张浦镇","320583108":"千灯镇","320583400":"昆山开发区","320583401":"昆山旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320583.json
// module id = 971
// module chunks = 0